import Vue from 'vue';
import Element from 'element-ui';
import '@/style/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/zh-TW';

Vue.use(Element, { locale });
